import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqData } from '../../data/mock';

const FAQSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section 
      id="faq"
      ref={sectionRef}
      className="py-32 bg-[#efede6] relative overflow-hidden"
    >
      <div className="max-w-3xl mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <span className={`inline-block text-sm text-[#202020]/40 uppercase tracking-widest mb-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            FAQ
          </span>
          <h2 className={`text-3xl md:text-4xl lg:text-5xl font-normal text-[#202020] tracking-tight transition-all duration-1000 delay-150 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            Questions You Might Have
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl shadow-lg border border-[#202020]/10 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
              style={{ transitionDelay: `${(index + 2) * 30}ms` }}
            >
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full flex items-center justify-between py-6 px-6 text-left group"
              >
                <span className="font-medium text-[#202020] pr-4 group-hover:text-[#202020]/70 transition-colors">{faq.question}</span>
                <ChevronDown 
                  className={`w-5 h-5 text-[#202020]/40 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                />
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-[500px] pb-6' : 'max-h-0'}`}
              >
                <p className="text-[#202020]/60 leading-relaxed px-6">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
